import { z, type ZodArray, type ZodTypeAny } from 'zod';

/**
 * Wraps an array schema so that `null` / `undefined` from the backend is
 * coerced to `[]` before parsing. Several admin list endpoints emit a bare
 * `null` JSON token when the underlying table is empty — that would otherwise
 * fail the page render.
 */
export function nullableList<T extends ZodTypeAny>(schema: T): z.ZodEffects<ZodArray<T>, z.infer<T>[], unknown> {
  return z.preprocess((raw) => raw ?? [], z.array(schema));
}

/**
 * Render a ZodError as `path: message` lines — `items.12.baseline.en: Invalid
 * input`. Capped, because the point is a line an operator can paste into a bug
 * report, not a dump of every issue in a 600-row page.
 */
export function formatZodIssues(error: z.ZodError, max: number): string[] {
  return error.issues
    .slice(0, max)
    .map((i) => `${i.path.length > 0 ? i.path.join('.') : '(root)'}: ${i.message}`);
}
